const initNewestItems = () => {
	const newest = document.querySelectorAll('.newest');

	newest.forEach(section => {
		let sectionSwiper = section.querySelector('.newest__swiper');
		if (sectionSwiper) {
			sectionSwiper = sectionSwiper.className.split(' ')[1];
		}
		if (!sectionSwiper) {
			return false;
		}
		const swiper = new Swiper(`.${sectionSwiper}`, {
			slidesPerView: 'auto',
			spaceBetween: 24,
			centeredSlides: true,
			loop: true,
			grabCursor: true,
			scrollbar: {
				draggable: true,
				el: '.swiper-scrollbar',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					centeredSlides: false,
				}
			}
		});
	});
}

window.addEventListener('DOMContentLoaded', () => {
	initNewestItems();
});